import useClientState from '@/state/useClientState';

export const useWeekday = () => {
  const weekDay = useClientState((state) => state.weekDay);
  return {
    weekDay,
  };
};
export default useWeekday;
